export const EXTENSION_NAME = "one-siam"
